import { Icon } from '@mui/material';
import './Tile.style.scss';

export const Tile = ({
  children,
  iconName,
  onClick,
  active,
}: {
  iconName: string;
  active?: boolean;
  children?: React.ReactNode;
  onClick?: () => void;
}) => {
  let tileClass = 'tile';
  let TileComponent: keyof JSX.IntrinsicElements = 'div';

  if (onClick) {
    tileClass += ' clickable';
    TileComponent = `button`;
  }

  if (active) {
    tileClass += ' active';
  }

  const handleOnClick = () => {
    if (onClick) {
      return onClick();
    }
    return undefined;
  };

  return (
    <TileComponent className={tileClass} onClick={handleOnClick}>
      {iconName && <Icon className="icon">{iconName}</Icon>}
      {children}
    </TileComponent>
  );
};
